// 路由,路径相关
export const isYach = /Yach/i.test(navigator.userAgent);
export const PATH_WIN_DOWNLOAD =
  "https://yach-static.zhiyinlou.com/html/dingding-0.5/index.html";
//"https://yach-static.zhiyinlou.com/client/dingding/DingTalk_v4.7.9.202.exe";
export const PATH_MAC_DOWNLOAD =
  "https://yach-static.zhiyinlou.com/html/dingding-0.5/index.html";
export const PATH_LOGIN = "/login";

//404 page
export const PATH_NOT_FOUND = "/404";
// 403 没有权限
export const PATH_403 = "/403";
export const PATH_PERMISSION = '/permission';
export const PATH_PERMISSION_NO = '/permission/no';
// 非钉钉打开
export const PATH_NO_DD = "/nodd";
// 非PC打开
export const PATH_NOPC = "/nopc";
// 周报
export const PATH_WEEKLY = "/weekly";
export const PATH_WEEKLY_WRITE = "/weekly/writeWeekly";

// 日报
export const PATH_DAILY = "/daily";
export const PATH_DAILY_WRITE = "/daily/writeDaily";

// 我的
export const PATH_MYINFO_OKR = "/myinfo/myokr";
export const PATH_MYINFO_GROUP = "/myinfo/group";
export const PATH_MYINFO_MYTIM = "/myinfo/mytim";
export const PATH_MYINFO_FOCUS = "/myinfo/focus";
export const PATH_TEAM_WORK = "/myinfo/teamwork";
export const PATH_MY_MARK = "/myinfo/mymark";
export const PATH_TOP_SAME_LEVEL = "/myinfo/topsamelevel";
export const PATH_MY_SUBORDINATE = "/myinfo/subordinate";
export const PATH_MYINFO_COLLECT = "/myinfo/collect";

export const PATH_ADD_OKR = "/myinfo/addokr";
export const PATH_FRIENDLY_TIPS = "/friendlyTips";
export const PATH_ADD_SUCCESS = "/myinfo/addsuccess";
export const PATH_MYINFO_DETAIL = "/myinfo/myokr/OkrDetail"; //详情、查看

// 我的组织
export const PATH_MYORG = "/myorg";

// KPI
export const PATH_KPI = "/kpi/data";

// 360
export const PATH_E360 = "/e360/up";

// NEW360
export const PATH_NEW360 = "/new360";

//消息列表
export const PATH_MESSAGE = "/messagelist";
//360测评报告
export const PATH_REPORT360 = "/report360";
//360测评总闸
export const PATH_FRAME360 = "/frame360";

//新详情
export const PATH_NEW_DETAIL = "/detail";

// 打分页
export const PATH_SCORE = "/score";

// 数据看板
export const PATH_DATA_USAGE = "/data/usage";
export const PATH_DATA_PERSON = "/data/person";
export const PATH_DATA_WEEK = "/data/week";
export const PATH_DATA_ACTIVATION = "/data/activation";

// 手册
export const PATH_TEACH = "/teach";
// 1.okr 手册
export const PATH_TEACH_OKR = "/teach/okr";
// 2.周报 手册
export const PATH_TEACH_WEEKLY = "/teach/weekly";

// 搜索列表页面
export const PATH_SEARCH_PAGE = "/searchpage";

// evaluation   360 测评
export const PATH_EVALUATION360 = "/evaluation360";
export const PATH_NEW_360 = "/new360";
export const PATH_EVALUATION360_INFORM = "/evaluation360/inform";

export const PATH_WEEKLY_IP = "http://" + window.location.hostname + ":8004";
console.log("process.env.NODE_ENV", process.env.NODE_ENV);

export const PATH_OKR_AUTHORIZATION =
  process.env.NODE_ENV === "development"
    ? PATH_LOGIN + "?token=development"
    : PATH_LOGIN + "?common_future=okr";
export const PATH_WEEKLY_AUTHORIZATION =
  process.env.NODE_ENV === "development"
    ? PATH_LOGIN + "?token=development"
    : PATH_LOGIN + "?common_future=weekly";
export const PATH_DAILY_AUTHORIZATION =
  process.env.NODE_ENV === "development"
    ? PATH_LOGIN + "?token=development"
    : PATH_LOGIN + "?common_future=daily";
export const PATH_FORCE_AUTHORIZATION =
  process.env.NODE_ENV === "development"
    ? PATH_LOGIN + "?token=development"
    : PATH_LOGIN + "?common_future=forceRedirect";
// export const PATH_ZHIYINLOU_YACH_SHARE =
//   process.env.NODE_ENV == "development"
//     ? PATH_LOGIN + "?token=development"
//     : "https://sso.100tal.com/login/" + process.env.VUE_APP_DINGDING_KEY;

// export const PATH_HOME = PATH_MYINFO_OKR;
export const PATH_HOME = PATH_WEEKLY;
export const PATH_HOME_YACH = PATH_MYINFO_OKR;
export const PATH_READ_DAILY = PATH_DAILY;
// 分享 移动端url

// 分享 移动端 OKR
export const PATH_DINGDING_OKR = isYach
  ? process.env.VUE_APP_YACH_SSO_URL +
  process.env.VUE_APP_YACH_YD_KEY +
  "?redirect=/singleObjectiveDetail?"
  : "https://sso.100tal.com/login/" +
  process.env.VUE_APP_DINGDING_KEY +
  "?redirect=/singleObjectiveDetail?"; // id | title

// 分享 移动端 O
export const PATH_DINGDING_O = isYach
  ? process.env.VUE_APP_YACH_SSO_URL +
  process.env.VUE_APP_YACH_YD_KEY +
  "?redirect=/singleObjectiveDetail?"
  : "https://sso.100tal.com/login/" +
  process.env.VUE_APP_DINGDING_KEY +
  "?redirect=/singleObjectiveDetail?"; // id

export const COMMON_FUTURE_MAP_URL = {
  weekly: PATH_WEEKLY_AUTHORIZATION,
  okr: PATH_OKR_AUTHORIZATION,
  daily: PATH_DAILY_AUTHORIZATION,
  forceRedirect: PATH_FORCE_AUTHORIZATION
};
